module.exports = __webpack_public_path__ + "img/imweb_design_5.25c157c0.png";